import { Component, TemplateRef } from '@angular/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { HomeService } from '../../../services/home/home.service';
import { Router } from '@angular/router';
import { CHANNEL_MAP_PR, CHANNEL_MAP_PR_Swedish } from 'src/app/shared/mocks/home.mock';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { SharedService } from 'src/app/shared/services/shared/shared.service';
import { AppUtil } from 'src/app/core/utils/utils';
import { config } from 'src/assets/config/config';
import { UserService } from '../../../services/user.service';
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { Country } from 'src/app/shared/country.type';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent {
	public helpfulLinksList: Array<any> = [];
	private languageSubscription: Subscription;
	public unsubscribe$ = new Subject();
	public serverError = false;
	private currentLang: string = 'sv';
	setUserType: string;
	countryData: any;
	userCards: any;
	public countryId: any;
	constructor(private homeService: HomeService,private userService: UserService, private modalService: BsModalService, private router: Router, private translateService: TranslateService, private commonService: CommonService, private sharedService: SharedService,     public modalRef: BsModalRef,
		) {}

	ngOnInit(): void {
		this.loadCountryData();
		this.languageSubscription = this.commonService.language$.subscribe((res) => {
			this.currentLang = res;
			this.getHelpfulLinksList(this.currentLang, 'Private');
		  });
		  
		this.clearValues();
		// this.getHelpfulLinksList();
	}
	loadCountryData() {
		// Assign the imported JSON data to a variable
		let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
		this.countryData = config[country];
		this.userCards = config[country]?.landingPageDetails?.userCards;
	  }
	 /**
   * @description Method to clear saved values
   */
	  public clearValues (): void {
		AppUtil.deleteSessionStorage("firstDrop");
		AppUtil.deleteSessionStorage("secondDrop");
		AppUtil.deleteSessionStorage("firstDropOption");
		AppUtil.deleteSessionStorage("secondDropOption");
		AppUtil.deleteSessionStorage("thirdDrop");
		AppUtil.deleteSessionStorage("thirdDropOption");
	  }

	navigateToPrivate(): void {
		this.countryId = this.commonService.getCountryId();
		sessionStorage.setItem('userType','Private');
		let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
		const path = `/${config[country]?.region}/private`;
		this.router.navigate([path]);
	}
	navigateToBusiness(): void {
		sessionStorage.setItem('userType','Business');
		let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
		const path = `${config[country]?.region}/business`;
		this.router.navigate([path]);
	}
	 navigateNonCustomer() {
		sessionStorage.setItem('userType','NonCustomer');
		let country: Country  = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
		const path = `${config[country]?.region}/non-customer`;
		this.router.navigate([path]);
      }
	  openModalOrRedirectOcta(template: TemplateRef<any>): void {
		let token = localStorage.getItem(this.countryId+"_token");
		if(token) {
		  this.userService.doLogin();
		} else {
		  const config: ModalOptions = { class: "modal-dialog-centered modal-lg" };
		  this.modalRef = this.modalService.show(template, config);
		}
	 
	  }
	usercardClicked(userCard: any) {
		const clickHandlerFunction = eval(userCard.clickHandler); // Dynamically evaluate the string
		if (typeof clickHandlerFunction === 'function') {
			clickHandlerFunction.call(this); // Call the function
		}
	}
	public getHelpfulLinksList (lang: string, userType:string): void {		 
		this.homeService.getHomeData(lang, userType)
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe((resp) => {
		  if (resp) {
			this.helpfulLinksList = (resp?.helpfulLinksList) ? resp?.helpfulLinksList[0]?.Channel_List : [];
		  }
		},
		  (err) => {
			if (err?.error?.StatusCode === "500") {
			  this.serverError = true;
			}
		  });
	}

}
